import React from "react"
import Divider from "@material-ui/core/Divider"
import { Link } from "gatsby"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core"
const useStyles = makeStyles(theme => ({
  root: {
    width: "90%",
    margin: "8px auto",
    color: "grey",
    fontSize: '9px'
  },
  celda: {
    textAlign: "center",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  right: {},
  title: {},
}))
const Pie = () => {
  const classes = useStyles()
  return (
    <div style={{marginTop:'9px'}}>
      <Divider />
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={3}>
            <div className={classes.celda}>☎ (+54 11) 4454-8343</div>
            <div className={classes.celda}>info@fiammengo.com</div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.celda}>Icons made by <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">Smashicons</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
            </div>
            <div className={classes.celda}></div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.celda}>Sitio creado por: Fiammengo SRL</div>
            <div className={classes.celda}>Icons made by <a href="https://www.flaticon.com/authors/eucalyp" title="Eucalyp">Eucalyp</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a></div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.celda}>
              <span style={{ paddingRight: 3 }}>Copyright ©</span>
              <Link to="/contacto/" activeClassName="perfil" className="perfil">
                Fiammengo SRL
              </Link>
            </div>
            <div className={classes.celda}>
              <Link to="/politica/" activeClassName="perfil" className="perfil">
                Ver política de privacidad
              </Link>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default Pie
